webpackJsonp([27],{

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(39)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(117),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 116:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('keep-alive', {
    attrs: {
      "exclude": "comment"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('music')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('audio', {
    attrs: {
      "src": _vm.playurl,
      "id": "audio"
    },
    on: {
      "timeupdate": _vm.playingtime,
      "error": _vm.errormp3,
      "waiting": _vm.waiting,
      "ended": _vm.next_music,
      "canplay": function($event) {
        _vm.setplaying(true)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

module.exports = VueRouter;

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(16);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(15);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(24);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(38);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var limit = 20;
exports.default = {
	index_rec: function index_rec() {
		var banner = (0, _axios2.default)("banner");
		var pl = (0, _axios2.default)('personalized');
		var ns = (0, _axios2.default)('personalized/newsong');
		var mv = (0, _axios2.default)('personalized/mv');
		var djprogram = (0, _axios2.default)('personalized/djprogram');
		return _axios2.default.all([banner, pl, ns, mv, djprogram]).then(_axios2.default.spread(function (a, b, c, d, e) {
			return _promise2.default.resolve([a.data.banners, b.data.result, c.data.result, d.data.result, e.data.result]);
		}));
	},
	index_plcate: function index_plcate() {
		return (0, _axios2.default)("playlist/catlist");
	},
	index_playlist: function index_playlist(type, offset) {
		return (0, _axios2.default)("top/playlist?limit=" + limit + '&offset=' + offset + '&type=' + type);
	},
	index_dj: function index_dj() {
		var cate = (0, _axios2.default)("djradio/catelist");
		var rec_p = (0, _axios2.default)("program/recommend");
		var rec_dj = (0, _axios2.default)("djradio/recommend");
		var djlist = this.index_djlist(0);
		return _axios2.default.all([cate, rec_p, rec_dj, djlist]).then(_axios2.default.spread(function (a, b, c, d) {
			return _promise2.default.resolve([a, b, c, d]);
		}));
	},
	index_djlist: function index_djlist(offset) {
		return (0, _axios2.default)("djradio/hot?limit=" + limit + '&offset=' + offset);
	},
	index_hqpl: function index_hqpl(cat, offset) {
		return (0, _axios2.default)("top/playlist/highquality", {
			params: {
				type: cat,
				offset: offset,
				limit: limit
			}
		});
	},
	likeall: function likeall() {
		return (0, _axios2.default)("likelist");
	},
	index_sort: function index_sort() {
		return (0, _axios2.default)("toplist/detail");
	},
	search: function search(name, type, offset) {
		return (0, _axios2.default)("search?keywords=" + name + '&type=' + type + '&limit=' + limit + '&offset=' + offset);
	},
	search_suggest: function search_suggest(s, t) {
		return (0, _axios2.default)("search/suggest?keywords=" + s);
	},
	search_hot: function search_hot(s, t) {
		return (0, _axios2.default)("search/hot");
	},
	search_multimatch: function search_multimatch(s, t) {
		return (0, _axios2.default)("search/multimatch?type=" + t + '&keywords=' + s);
	},
	playlist: function playlist(id, offset, limit) {
		return _axios2.default.get("playlist/detail?id=" + id + '&offset=' + offset + '&limit=' + limit);
	},
	album: function album(id) {
		return (0, _axios2.default)("album/detail?id=" + id);
	},
	artist: function artist(id) {
		return (0, _axios2.default)("artist?id=" + id);
	},
	artist_album: function artist_album(id, offset) {
		return (0, _axios2.default)("artist/album?id=" + id + '&offset=' + offset + '&limit=' + limit);
	},
	artist_mv: function artist_mv(id, offset) {
		return (0, _axios2.default)("artist/mv?id=" + id + '&offset=' + offset + '&limit=' + limit);
	},
	artist_desc: function artist_desc(id) {
		return (0, _axios2.default)("artist/desc?id=" + id);
	},
	artist_simi: function artist_simi(id) {
		return (0, _axios2.default)("artist/simi?id=" + id);
	},
	lyric: function lyric(id) {
		return (0, _axios2.default)("lyric?id=" + id);
	},
	songtrack: function songtrack(id, t, d) {
		return (0, _axios2.default)("song/tracks", {
			params: {
				id: id,
				auth: true,
				r: !d ? '' : 'del',
				op: !t ? 'like' : 'trash'
			}
		});
	},
	tracktpl: function tracktpl(sid, pid) {
		var add = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

		var op = add ? 'add' : 'del';
		return (0, _axios2.default)("playlist/tracks?pid=" + pid + "&op=" + op + "&tracks=" + sid);
	},
	dislike: function dislike(id, type) {
		return (0, _axios2.default)("recommend/dislike", {
			params: {
				id: id,
				type: type
			}
		});
	},
	comments: function comments(id, offset, type) {
		id = (type == 1 ? '' : type == 3 ? 'A_DJ_1_' : 'R_SO_4_') + id;
		return (0, _axios2.default)("comments?id=" + id + '&offset=' + offset + '&limit=' + limit);
	},
	music_url: function music_url(id) {
		return (0, _axios2.default)("music/url?id=" + id + '&br=128000');
	},
	music_detail: function music_detail(id) {
		var _this = this;

		return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
			return _regenerator2.default.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							return _context.abrupt("return", (0, _axios2.default)("music/detail?id=" + id));

						case 1:
						case "end":
							return _context.stop();
					}
				}
			}, _callee, _this);
		}))();
	},
	fm: function fm() {
		return (0, _axios2.default)("fm");
	},
	simi: function simi(id) {
		var pl = (0, _axios2.default)("simi/playlist", {
			params: {
				id: id,
				auth: true
			}
		});
		var song = (0, _axios2.default)("simi/song?id=" + id);
		var user = (0, _axios2.default)("simi/user?id=" + id);
		return _axios2.default.all([pl, song, user]).then(_axios2.default.spread(function (a, b, c) {
			return _promise2.default.resolve([a.data.playlists, b.data.songs, c.data.userprofiles]);
		}));
	},
	record: function record() {
		var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

		return (0, _axios2.default)("record?type=" + t);
	},
	login: function login(name, pwd) {
		var data = {
			email: name,
			password: pwd,
			phone: name
		};
		return (0, _axios2.default)(/^0\d{2,3}\d{7,8}$|^1[34578]\d{9}$/.test(name) ? "login/cellphone" : "login", {
			params: data
		});
	},
	mv: function mv(id) {
		var mv = _axios2.default.get('mv?id=' + id);
		var simi = (0, _axios2.default)("mv/simi?id=" + id);
		return _axios2.default.all([mv, simi]).then(_axios2.default.spread(function (a, b) {
			return _promise2.default.resolve([a.data.data, b.data.mvs]);
		}));
	},
	dj_detail: function dj_detail(id) {
		return (0, _axios2.default)("dj/detail?id=" + id);
	},
	dj_getprogram: function dj_getprogram(id, offset) {
		return (0, _axios2.default)("dj/program", {
			params: {
				id: id,
				offset: offset,
				limit: limit
			}
		});
	},
	dj_sub: function dj_sub(id, t) {
		return (0, _axios2.default)("dj/sub", {
			params: {
				id: id,
				t: t
			}
		});
	},
	program_detail: function program_detail(id) {
		return (0, _axios2.default)("program/detail", {
			params: {
				id: id
			}
		});
	},
	program_like: function program_like(id, t) {
		return (0, _axios2.default)("resource/like", {
			params: {
				id: id,
				t: t
			}
		});
	},
	user_detail: function user_detail(id) {
		return (0, _axios2.default)("user/detail?uid=" + id);
	},
	user_playlist: function user_playlist(id, offset) {
		return (0, _axios2.default)("user/playlist?uid=" + id + '&offset=' + offset + '&limit=' + limit);
	},
	user_radio: function user_radio(id) {
		return (0, _axios2.default)("user/radio", {
			params: {
				uid: id
			}
		});
	},
	user_event: function user_event(id, offset) {
		return (0, _axios2.default)("event/get", {
			params: {
				id: id,
				offset: offset,
				limit: limit
			}
		});
	},
	user_subcount: function user_subcount(id) {
		return (0, _axios2.default)("user/subcount", {
			params: {
				id: id,
				auth: true
			}
		}, {
			params: {
				auth: true
			}
		});
	},
	user_cloud: function user_cloud(offset) {
		return (0, _axios2.default)("user/cloud", {
			params: {
				offset: offset,
				limit: limit,
				auth: true
			}
		});
	},
	user_recs: function user_recs() {
		return (0, _axios2.default)("recommend/songs", {
			params: {
				auth: true
			}
		});
	},
	user_sublist: function user_sublist(t, offset) {
		return (0, _axios2.default)("sublist/" + t, {
			params: {
				auth: true,
				offset: offset,
				limit: limit
			}
		});
	},
	event_list: function event_list(offset) {
		return (0, _axios2.default)("event/list", {
			params: {
				auth: true,
				offset: offset,
				limit: limit
			}
		});
	},
	mine: function mine() {
		var _this2 = this;

		return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
			return _regenerator2.default.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.next = 2;
							return (0, _axios2.default)("mine");

						case 2:
							return _context2.abrupt("return", _context2.sent);

						case 3:
						case "end":
							return _context2.stop();
					}
				}
			}, _callee2, _this2);
		}))();
	}
};

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

module.exports = axios;

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = Vuex;

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__(14);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(119);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
var router = new _vueRouter2.default({
	routes: [{
		path: '/search',
		name: 'search',
		component: function component(resolve) {
			return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(144)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/simi/:id',
		name: 'simi',
		component: function component(resolve) {
			return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(145)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/sortmv',
		name: 'sortmv'
	}, {
		path: '/mv/:id',
		name: 'mv',
		meta: {
			isKeepAlive: false
		},
		component: function component(resolve) {
			return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(133)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/comment/:id',
		name: 'comment',
		meta: {
			isKeepAlive: false
		},
		component: function component(resolve) {
			return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(124)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/login',
		name: 'login',
		meta: {
			isKeepAlive: false
		},
		component: function component(resolve) {
			return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(132)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/album/:id',
		name: 'album',
		component: function component(resolve) {
			return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(122)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/artist/:id',
		name: 'artist',
		component: function component(resolve) {
			return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(123)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/user/:id',
		name: 'user',
		component: function component(resolve) {
			return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(147)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/radio/:id',
		name: 'radio',
		component: function component(resolve) {
			return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(142)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/playlist/:id',
		name: 'playlist',
		component: function component(resolve) {
			return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(141)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/me',
		name: 'me',
		meta: {
			'auth': true
		},
		component: function component(resolve) {
			return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(136)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/favradio',
		name: 'favradio',
		component: function component(resolve) {
			return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(135)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/sublist',
		name: 'sublist',
		component: function component(resolve) {
			return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(146)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/hqplaylist',
		name: 'hqplaylist',
		component: function component(resolve) {
			return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(131)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/recsong',
		name: 'recsong',
		meta: {
			'auth': true
		},
		component: function component(resolve) {
			return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(143)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/cloud',
		name: 'cloud',
		component: function component(resolve) {
			return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(134)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		}
	}, {
		path: '/play',
		component: function component(resolve) {
			return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(138)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		},
		children: [{
			path: "/playing/:id",
			name: 'playing',
			component: function component(resolve) {
				return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(139)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
			}

		}, {
			path: 'fm',
			name: 'fm',
			component: function component(resolve) {
				return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(137)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
			}
		}, {
			path: '/program/:id',
			name: 'program',
			component: function component(resolve) {
				return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(140)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
			}
		}]
	}, {
		path: '/home',
		name: 'home',
		component: function component(resolve) {
			return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(125)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
		},
		children: [{
			path: "index",
			name: 'index',
			component: function component(resolve) {
				return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(128)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
			},
			children: [{
				path: 'find',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(127)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
				}
			}, {
				path: 'playlist',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(129)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
				}
			}, {
				path: 'djlist',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(126)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
				}
			}, {
				path: 'sort',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(130)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
				}
			}]
		}]
	}, {
		path: '*',
		redirect: '/home/index/find'
	}]
});

router.beforeEach(function (to, from, next) {
	if (to.meta.auth && !logined) {
		console.error("需先登录");
		next(false);
		router.push({
			name: 'login'
		});
	} else {
		next();
	}
});
exports.default = router;

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(16);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(15);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = __webpack_require__(14);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(40);

var _vuex2 = _interopRequireDefault(_vuex);

var _api = __webpack_require__(25);

var _api2 = _interopRequireDefault(_api);

var _utils = __webpack_require__(65);

var _utils2 = _interopRequireDefault(_utils);

var _mintUi = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _vuex2.default.Store({
	state: {
		music: {
			al: {},
			ar: [{}],
			artists: [{}],
			album: {}
		},
		playing: false,
		lrcObj: {
			lrc: [{}]
		},
		musicloading: true,
		playurl: '',
		musicload: false,
		playtype: 1,
		scrolltop: 0,
		commentscount: 0,
		list_am: [],
		index_am: 0,
		list_fm: [],
		index_fm: 0,
		list_dj: [],
		index_dj: 0,
		playtime: 0,
		likeall: "",
		user: JSON.parse(localStorage.getItem('user')) || {},
		bgmchange: false,
		uplaylist: [],
		shuffle_am: 0,
		shuffle_dj: 0
	},
	mutations: {
		scroll: function scroll(state, st) {
			state.scrolltop = st;
		},
		localuser: function localuser(state, user) {
			localStorage.setItem("user", (0, _stringify2.default)(user));
			state.user = user;
			logined = user.account ? true : false;
		},
		setbgmchange: function setbgmchange(state, t) {
			state.bgmchange = t;
		},
		setplaying: function setplaying(state, t) {
			state.playing = t;
			if (t) {
				state.musicload = true;
				state.musicloading = false;
				audio.play();
			} else {
				audio.pause();
			}
		},
		setmusic: function setmusic(state, res) {
			res.heart = false;
			if (res.id && state.likeall.indexOf(res.id) > -1) {
				res.heart = true;
			}
			state.music = res;
		},
		waiting: function waiting(state) {
			state.musicloading = true;
		},
		setlrc: function setlrc(state, res) {
			state.lrcObj = res;
		},
		commentscount: function commentscount(state, c) {
			state.commentscount = c;
		},
		resetmusic: function resetmusic(state) {
			document.getElementById('audio').pause();
			state.commentscount = 0;
			state.playurl = "";
			state.playing = false;
			state.lrcObj = {
				lrc: [{}]
			};
			state.musicloading = true;
			state.playtime = 0;
		},
		setmusic_url: function setmusic_url(state, url) {
			if (!url) {
				(0, _mintUi.Toast)({
					message: '获取歌曲链接失败',
					duration: 3000
				});
				return;
			}
			state.playurl = url;
		},
		list_remove: function list_remove(state, index) {},
		playtimechange: function playtimechange(state, time) {
			state.playtime = Math.round(time * 1000);
		},
		setplaytype: function setplaytype(state, type) {
			state.playtype = type;
		},
		setmusicload: function setmusicload(state, type) {
			state.musicload = type;
		},
		setplaylist: function setplaylist(state, arr) {
			state.playtype == 1 ? state.list_am = arr : state.list_dj = arr;
		},
		setindex: function setindex(state, i) {
			state.playtype == 1 ? state.index_am = i : state.index_dj = i;
		},
		playindex: function playindex(state, i) {
			if (state.playtype == 1) {
				state.index_am = i;
				state.music = state.music.id == state.list_am[i].id ? state.music : state.list_am[i];
			} else {
				state.index_dj = i;
				state.music = state.music.id == state.list_dj[i].id ? state.music : state.list_dj[i];
			}
		},
		delplaylist: function delplaylist(state, i) {
			if (i > -1) {
				state.playtype == 1 ? state.index_am-- : state.index_dj--;
				state.playtype == 1 ? state.list_am.splice(i, 1) : state.list_dj.splice(i, 1);
			} else {

				state.playtype == 1 ? state.index_am = 0 : state.index_dj = 0;
				state.playtype == 1 ? state.list_am = [] : state.list_dj = [];
			}
		},
		shuffle: function shuffle(state, i) {
			if (state.playtype == 1) {
				state.shuffle_am = state.shuffle_am == 2 ? 0 : state.shuffle_am + 1;
			} else {
				state.shuffle_dj = state.shuffle_dj == 2 ? 0 : state.shuffle_dj + 1;
			}
		},
		next: function next(state) {
			var musicend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (state.playtype == 1) {
				if (!state.list_am.length) return;
				state.index_am++;
				if (state.shuffle_am == 2) {
					var rang = Math.floor(state.list_am.length * Math.random());
					state.index_am = state.index_am == rang ? rang + 1 : rang;
				} else {
					!musicend && state.index_am++;
				}
				state.index_am = state.index_am >= state.list_am.length ? 0 : state.index_am;
				state.music = state.list_am[state.index_am];
			} else if (state.playtype == 3) {
				if (!state.list_dj.length) return;
				state.index_dj++;
				state.index_dj = state.index_dj >= state.list_dj.length ? 0 : state.index_dj;
				state.music = state.list_dj[state.index_dj];
			}
		},
		prev: function prev(state) {
			console.log("prev");
			if (state.playtype == 1) {
				if (!state.list_am.length) return;
				state.index_am--;
				state.index_am = state.index_am < 0 ? state.list_am.length - 1 : state.index_am;
				state.music = state.list_am[state.index_am];
			} else if (state.playtype == 3) {
				if (!state.list_dj.length) return;
				state.index_dj--;
				state.index_dj = state.index_dj < 0 ? index_dj - 1 : state.index_dj;
				state.music = state.list_dj[state.index_dj];
			}
		},
		setfm: function setfm(state, fm) {
			state.index_fm = fm.index + 1;
			state.list_fm = fm.list;
			var res = state.list_fm[state.index_fm] || {};
			res.heart = false;
			if (res.id && state.likeall.indexOf(res.id) > -1) {
				res.heart = true;
			}
			state.music = res;
		},
		setuplaylist: function setuplaylist(state, res) {
			res = res.filter(function (i) {
				return i.creator.userId == state.user.account.id;
			});
			state.uplaylist = res;
			console.log("uplaylist", res);
		},
		setlikeall: function setlikeall(state, res) {
			state.likeall = res;
		}
	},
	actions: {
		next_music: function next_music(_ref, opt) {
			var commit = _ref.commit,
			    state = _ref.state,
			    dispatch = _ref.dispatch;

			console.log("end");
			commit("setbgmchange", true);
			if (state.playtype == 2) {
				dispatch("next_fm");
			} else {
				commit("next", true);
				dispatch("only_murl");
			}
		},
		next_fm: function next_fm(_ref2) {
			var commit = _ref2.commit,
			    state = _ref2.state;

			if (state.index_fm >= state.list_fm.length - 1) {
				_api2.default.fm().then(function (res) {
					commit("setfm", {
						list: res.data.data,
						index: -1
					});
				});
			} else {
				commit('setfm', {
					list: state.list_fm,
					index: state.index_fm
				});
			}
		},
		getmusic: function getmusic(_ref3, id) {
			var _this = this;

			var commit = _ref3.commit;
			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return _api2.default.music_detail(id);

							case 2:
								res = _context.sent;

								commit("setmusic", res.data.songs[0] || {});

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		getmusic_url: function getmusic_url(_ref4, id) {
			var _this2 = this;

			var commit = _ref4.commit,
			    dispatch = _ref4.dispatch,
			    state = _ref4.state;
			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return dispatch('getmusic', id);

							case 2:
								_api2.default.music_url(state.music.id).then(function (res) {
									commit('setmusic_url', res.data.data[0].url);
								});

							case 3:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		only_murl: function only_murl(_ref5) {
			var commit = _ref5.commit,
			    state = _ref5.state;

			if (!state.music.id) return;
			_api2.default.music_url(state.playtype != 3 ? state.music.id : state.music.mainSong.id).then(function (res) {
				commit('setmusic_url', res.data.data[0].url);
			});
		},
		getlike: function getlike(_ref6) {
			var _this3 = this;

			var commit = _ref6.commit,
			    state = _ref6.state;
			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_api2.default.likeall().then(function (res) {
									commit("setlikeall", (res.data.ids || []).join(","));
								});
								_context3.t0 = state.user.account;

								if (!_context3.t0) {
									_context3.next = 5;
									break;
								}

								_context3.next = 5;
								return _api2.default.user_playlist(state.user.account.id, 0).then(function (res) {
									commit("setuplaylist", res.data.playlist || []);
								});

							case 5:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		heart: function heart(_ref7, opt) {
			var _this4 = this;

			var state = _ref7.state,
			    commit = _ref7.commit,
			    dispatch = _ref7.dispatch;
			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								if (state.music.id) {
									_context4.next = 2;
									break;
								}

								return _context4.abrupt('return');

							case 2:
								_api2.default.songtrack(opt.id, opt.t, opt.del).then(function (res) {
									if (res.data.code == 200) {
										dispatch("getlike");
									}
								});

							case 3:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))();
		},
		getlrc: function getlrc(_ref8, id) {
			var state = _ref8.state,
			    commit = _ref8.commit;

			_api2.default.lyric(id).then(function (res) {
				var lrc = _utils2.default.parse_lrc(res.data.lrc && res.data.lrc.lyric ? res.data.lrc.lyric : '');
				res.data.lrc = lrc.now_lrc;
				res.data.scroll = lrc.scroll ? 1 : 0;
				commit("setlrc", res.data);
			}).catch(function () {
				commit("setlrc", {
					code: 500
				});
			});
		},
		localuser: function localuser(_ref9) {
			var _this5 = this;

			var state = _ref9.state,
			    commit = _ref9.commit;
			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
				return _regenerator2.default.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_context5.next = 2;
								return _api2.default.mine().then(function (res) {
									commit("localuser", res.data);
								});

							case 2:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		tracktpl: function tracktpl(_ref10, opt) {
			var state = _ref10.state,
			    dispatch = _ref10.dispatch;

			_api2.default.tracktpl(opt.id, opt.pid, opt.add).then(function (res) {
				if (res.data.code == 200) {
					(0, _mintUi.Toast)({
						message: '添加成功！',
						duration: 2000
					});
					dispatch("getlike");
				} else {
					(0, _mintUi.Toast)({
						message: res.data.code == 502 ? '歌曲已存在' : '添加失败！',
						duration: 2000
					});
				}
			});
		}
	}
});

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(39)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(116),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(73);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var time = function time(date) {
	var d = new Date(date);
	var year = d.getFullYear();
	var month = d.getMonth() + 1;
	var day = d.getDate();
	var hour = d.getHours();
	var minute = d.getMinutes();
	var second = d.getSeconds();
	var jm = new Date(),
	    Fo = jm.getTime() - date;
	if (Fo <= 6e4) return "刚刚";
	var Qq = jm.getHours() * 36e5 + jm.getMinutes() * 6e4 + jm.getSeconds() * 1e3;
	if (day == jm.getDate()) {
		if (Fo < 36e5) {
			var bOh = Math.floor(Fo / 6e4);
			return bOh + "分钟前";
		}
		return [hour, minute].map(function (n) {
			n = n.toString();
			return n[1] ? n : '0' + n;
		}).join(':');
	} else {
		if (Fo < Qq + 864e5) {
			return "昨天" + [hour, minute].map(function (n) {
				n = n.toString();
				return n[1] ? n : '0' + n;
			}).join(':');
		} else {
			var hq = jm.getFullYear(),
			    bOg = new Date(hq, 0, 1);
			var Qq = jm.getTime() - bOg.getTime();
			if (Fo < Qq) {
				return year + "年" + month + "月" + day + "日" + [hour, minute].map(function (n) {
					n = n.toString();
					return n[1] ? n : '0' + n;
				}).join(':');
			}
			return year + "年" + month + "月" + day + "日";
		}
	}
};

function deepclone(obj) {
	var str,
	    newobj = obj.constructor === Array ? [] : {};
	if ((typeof obj === "undefined" ? "undefined" : (0, _typeof3.default)(obj)) !== 'object') {
		return;
	} else if (JSON) {
		str = (0, _stringify2.default)(obj), newobj = JSON.parse(str);
	} else {
		for (var i in obj) {
			newobj[i] = (0, _typeof3.default)(obj[i]) === 'object' ? deepclone(obj[i]) : obj[i];
		}
	}
	return newobj;
}

function parse_lrc(lrc_content) {
	var now_lrc = [];
	var lrc_row = lrc_content.split("\n");
	var scroll = true;
	for (var i in lrc_row) {
		if (lrc_row[i].indexOf(']') == -1 && lrc_row[i]) {
			now_lrc.push({
				lrc: lrc_row[i]
			});
		} else if (lrc_row[i] != "") {
			var tmp = lrc_row[i].split("]");
			for (var j in tmp) {
				scroll = false;
				var tmp2 = tmp[j].substr(1, 8);
				tmp2 = tmp2.split(":");
				var lrc_sec = parseInt(tmp2[0] * 60 + tmp2[1] * 1);
				if (lrc_sec && lrc_sec > 0) {
					var lrc = tmp[tmp.length - 1].replace(/(^\s*)|(\s*$)/g, "");
					lrc && now_lrc.push({
						lrc_sec: lrc_sec,
						lrc: lrc
					});
				}
			}
		}
	}
	if (!scroll) {
		now_lrc.sort(function (a, b) {
			return a.lrc_sec - b.lrc_sec;
		});
	}
	return {
		now_lrc: now_lrc,
		scroll: scroll
	};
};

function emoji(str) {
	if (!str) return;
	var bl = {
		"大笑": "86",
		"可爱": "85",
		"憨笑": "359",
		"色": "95",
		"亲亲": "363",
		"惊恐": "96",
		"流泪": "356",
		"亲": "362",
		"呆": "352",
		"哀伤": "342",
		"呲牙": "343",
		"吐舌": "348",
		"撇嘴": "353",
		"怒": "361",
		"奸笑": "341",
		"汗": "97",
		"痛苦": "346",
		"惶恐": "354",
		"生病": "350",
		"口罩": "351",
		"大哭": "357",
		"晕": "355",
		"发怒": "115",
		"开心": "360",
		"鬼脸": "94",
		"皱眉": "87",
		"流感": "358",
		"爱心": "33",
		"心碎": "34",
		"钟情": "303",
		"星星": "309",
		"生气": "314",
		"便便": "89",
		"强": "13",
		"弱": "372",
		"拜": "14",
		"牵手": "379",
		"跳舞": "380",
		"禁止": "374",
		"这边": "262",
		"爱意": "106",
		"示爱": "376",
		"嘴唇": "367",
		"狗": "81",
		"猫": "78",
		"猪": "100",
		"兔子": "459",
		"小鸡": "450",
		"公鸡": "461",
		"幽灵": "116",
		"圣诞": "411",
		"外星": "101",
		"钻石": "52",
		"礼物": "107",
		"男孩": "0",
		"女孩": "1",
		"蛋糕": "337",
		18: "186",
		"圈": "312",
		"叉": "313"
	};
	var emojiObjs = [];
	str = str.replace(/\[([^\[\]]+)\]/g, ':$1:');
	var eReg = new RegExp("[:]");
	var array = str.split(eReg);
	for (var i = 0; i < array.length; i++) {
		var ele = array[i];
		var emojiObj = {};
		if (bl[ele]) {
			emojiObj.node = "element";
			emojiObj.tag = "emoji";
			emojiObj.text = bl[ele];
		} else {
			emojiObj.node = "text";
			emojiObj.text = ele;
		}
		emojiObjs.push(emojiObj);
	}
	return emojiObjs;
}
exports.default = {
	time: time,
	clone: deepclone,
	parse_lrc: parse_lrc,
	emoji: emoji
};

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _music = __webpack_require__(115);

var _music2 = _interopRequireDefault(_music);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'app',
	components: {
		music: _music2.default
	}
};

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(64);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'music',
	methods: (0, _extends3.default)({
		playingtime: function playingtime(e) {
			this.$store.commit("playtimechange", document.getElementById("audio").currentTime);
		},
		errormp3: function errormp3(e) {}
	}, (0, _vuex.mapActions)(['next_music']), (0, _vuex.mapMutations)(['setplaying', 'waiting'])),
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['playurl', 'music', 'playtype']))
};

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(16);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(15);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(24);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(14);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(62);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(58);

var _router2 = _interopRequireDefault(_router);

__webpack_require__(60);

var _mintUi = __webpack_require__(26);

var _mintUi2 = _interopRequireDefault(_mintUi);

__webpack_require__(61);

var _store = __webpack_require__(59);

var _store2 = _interopRequireDefault(_store);

var _axios = __webpack_require__(38);

var _axios2 = _interopRequireDefault(_axios);

var _api = __webpack_require__(25);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_mintUi2.default);
var FastClick = __webpack_require__(63);
if ('addEventListener' in document) {
	document.addEventListener('DOMContentLoaded', function () {
		FastClick.attach(document.body);
	}, false);
}
_axios2.default.defaults.timeout = 5000;
_axios2.default.defaults.baseURL = 'https://wx.sqaiyan.com/';

_axios2.default.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
_axios2.default.interceptors.request.use(function (config) {
	if (config.params && config.params.auth && !logined) {
		_router2.default.push({
			name: 'login'
		});
		return _promise2.default.reject({
			"msg": '需先登录'
		});
	}
	return config;
}, function (err) {
	return _promise2.default.reject(err);
});

_axios2.default.interceptors.response.use(function (res) {
	if (res.data.code === 301) {
		console.log('未登录');
	} else if (res.data.code !== 200) {
		console.log('返回数据不正常');
	}
	return res;
}, function (error) {
	console.log('promise error:' + error);
	return _promise2.default.reject(error);
});
_vue2.default.prototype.$http = _axios2.default;
_vue2.default.config.productionTip = false;
var audio = null;
new _vue2.default({
	el: '#app',
	router: _router2.default,
	store: _store2.default,
	template: '<App/>',
	components: {
		App: _App2.default
	},
	mounted: function mounted() {
		var _this = this;

		return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
			return _regenerator2.default.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							audio = document.querySelector("#audio");
							_context.next = 3;
							return _this.$store.dispatch("localuser");

						case 3:
							_context.next = 5;
							return _this.$store.dispatch('getlike');

						case 5:
							window.onscroll = function () {
								_this.$store.commit("scroll", window.pageYOffset);
							};

						case 6:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this);
		}))();
	}
});
_vue2.default.filter('playcount', function (v) {
	if (!v) return "";
	return v < 1e4 ? v : (v / 1e4).toFixed(0) + '万';
});
_vue2.default.filter('dateM', function (v) {
	v = new Date(v);
	var y = v.getFullYear() == new Date().getFullYear() ? '' : v.getFullYear() + "-";
	var m = v.getMonth() + 1;
	m = m > 9 ? m : '0' + m;
	var d = v.getDate();
	d = d > 9 ? d : '0' + d;
	return y + m + "-" + d;
});
_vue2.default.filter('dateS', function (v) {
	v = new Date(v);
	var m = v.getMinutes();
	m = m > 9 ? m : '0' + m;
	var s = v.getSeconds();
	s = s > 9 ? s : '0' + s;
	return m + ':' + s;
});
_vue2.default.filter('time', function (date) {
	if (!date) return '';
	date = new Date(date);
	var m = date.getMonth() + 1;
	m = m > 9 ? m : '0' + m;
	var d = date.getDate();
	d = d > 9 ? d : '0' + d;
	return date.getFullYear() + '-' + m + '-' + d;
});
_vue2.default.filter("btdto", function (v) {
	v = new Date(v);
	var m = v.getMonth() + 1;
	var d = v.getDate();
	var xz = "魔羯水瓶双鱼牡羊金牛双子巨蟹狮子处女天秤天蝎射手魔羯".substr(m * 2 - (d < "102223444433".charAt(m - 1) - -19) * 2, 2);
	return xz + '座';
});

/***/ })

},[69]);


// WEBPACK FOOTER //
// static/js/app.9d112bcf7721232871cc.js